(function(){
    angular
        .module('appback')
        .directive('ngCoprocultivoco', coprocultivoco);

        coprocultivoco.$inject = ['$timeout','GenerallabService'];
        function coprocultivoco($timeout,GenerallabService){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/resultadopeticion/template?name=coprocultivoco.twig',
		          scope: {
                  //ngModel : '=',
                  item: '=',
                  animal: '='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
		            	scope.generalLab = GenerallabService;
		            	if(!scope.item.resultado){
			            		scope.item.resultado = { extra : { resultado : {  }}};
		            	}else{
			            	if(!scope.item.resultado.extra){
			            		scope.item.resultado.extra = { resultado : { }};
				            }else{
				            	if(!scope.item.resultado.extra.resultado){
				            		scope.item.resultado.extra.resultado = { };
					            }else{
					            	if(Array.isArray(scope.item.resultado.extra.resultado)){
				            			scope.item.resultado.extra.resultado = { };
					            	}
				       				//console.log("resmd");
				       				//console.log(scope.item.resultado.extra.resultado);

					            }
				            }
				        }

			        });
		        }
          }
      }
})();